import React from 'react'
import "../Styles/ThirdCard.scss"
import sad from "../assets/sad.svg"
const ThirdCard = ({result}) => {
  const accuracy = ((result?.correct / result?.totalQuestion) * 100).toFixed(0);
  return (
    <div className="thirdCardWrapper ">
      <div className="text1">Accuracy</div>
      <div className="text2">
        {accuracy}%
      </div>
      <div className="maindiv">
        <div style={{fontWeight:"700"}}>Topper accuracy - {result?.bestAccuracy}%</div>
        <div className="imgdiv">
          <img
            loading="lazy"
            src={sad}
            style={{width:"2.25rem","shrink":"0"}}
          />
          <div>
            <span style={{fontWeight:"600"}}>
              Better luck next time !{" "}
            </span>
            <br/>
           you are almost there. Keep working hard
          </div>
        </div>
      </div>
    </div>
  )
}

export default ThirdCard